module.exports = __webpack_public_path__ + "static/media/keyman-db-banner-short@2x.086af309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner-short@2x.png
// module id = 1289
// module chunks = 1